import { render, staticRenderFns } from "./editScene.vue?vue&type=template&id=fb902c24&scoped=true"
import script from "./editScene.vue?vue&type=script&lang=js"
export * from "./editScene.vue?vue&type=script&lang=js"
import style0 from "./editScene.vue?vue&type=style&index=0&id=fb902c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb902c24",
  null
  
)

export default component.exports